// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { toggleFiltersWidgetStyles } from "@west/App/Widgets/ToggleFilters/ToggleFilters";
import Filter from "@west/XDL/Icons/Filter";
import X from "@west/XDL/Icons/X";
import { buttonTransparent } from "@west/XDL/PreStyle/button";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

toggleFiltersWidgetStyles.filtersDrawer = {
    headlineTypographyProps: {
        forwardAs: "p",
        size: 16,
        weight: "bold",
        color: "text",
        lineHeight: "24px",
        css: css`
            letter-spacing: 0;
            margin: 0;
        `,
    },
    closeButtonIconProps: {
        src: X,
        size: 14,
        css: css`
            opacity: 0.66;
        `,
    },
    cssOverrides: {
        scrim: css`
            ${xScreen("lte", "md")} {
                top: 0;
            }
        `,
        drawerTitle: css`
            background: ${color("common.white")};
            padding: 12px 0;
            margin: 0 16px;
            border-bottom: 1px solid ${color("common.border")};
        `,
        headlineTypography: css`
            margin: 0;
        `,
        titleButton: css`
            ${buttonTransparent}
            padding: 8px;
            ${IconWrapper} {
                color: ${color("primary")};
            }
        `,

        drawerBody: css`
            width: 360px;
            ${xScreen("lte", "sm")} {
                top: 0;
                height: 100%;
                width: 100%;
            }
        `,
        drawerContent: css`
            overflow-x: hidden;
            padding: 12px 16px 0 16px;
            background: ${color("common.white")};
            height: 100%;
        `,
    },
};

toggleFiltersWidgetStyles.filterBtn = {
    typographyProps: {
        size: 16,
        weight: "bold",
        lineHeight: "17px",
        css: css`
            margin-bottom: 0;
            letter-spacing: 0;
        `,
    },
    icon: {
        iconProps: {
            size: 16,
            src: Filter,
            css: css`
                opacity: 0.66;
            `,
        },
    },
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            display: inline-flex;
        }
    `,
};
